export const REPORTS_MORTALITY_STORAGE_KEY = "reportsMortalityRedirect";

export const saveMortalityRedirect = (value) => {
  try {
    sessionStorage.setItem(REPORTS_MORTALITY_STORAGE_KEY, JSON.stringify(value));
  } catch (error) {
    console.warn("Unable to persist mortality redirect payload", error);
  }
};

export const readMortalityRedirect = () => {
  try {
    const raw = sessionStorage.getItem(REPORTS_MORTALITY_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.warn("Unable to read mortality redirect payload", error);
    return null;
  }
};

export const clearMortalityRedirect = () => {
  try {
    sessionStorage.removeItem(REPORTS_MORTALITY_STORAGE_KEY);
  } catch (error) {
    console.warn("Unable to clear mortality redirect payload", error);
  }
};
